import { type DatePickerProps } from ".";

export const datePickerGroupClassname = (
	isDisabled: boolean,
	size: DatePickerProps["size"],
	type: "standalone" | "embedded"
) => [
	"flex space-x-2 items-stretch group",
	"[&>*>svg]:fill-icon-default",
	{
		"bg-primary": type === "standalone",
		"ring-default": type === "standalone",
		"focus-within:ring-4": type === "standalone",

		"shadow-border-dropshadow-default": !isDisabled && type === "standalone",
		"focus-within:shadow-border-dropshadow-focus": !isDisabled && type === "standalone",
		"focus-within:hover:shadow-border-dropshadow-focus": !isDisabled && type === "standalone",
		"hover:shadow-border-dropshadow-hover": !isDisabled && type === "standalone",
		"active:shadow-border-dropshadow-active": !isDisabled && type === "standalone",

		"shadow-border-dropshadow-disabled": isDisabled && type === "standalone",
		"bg-tertiary": isDisabled,

		"rounded": size === "sm",
		"rounded-md": size === "md",
		"rounded-lg": size === "lg",

		"h-8": size === "sm",
		"h-[38px]": size === "md",
		"h-[46px]": size === "lg",

		"pl-2": size === "sm" && type !== "embedded",
		"pl-3": (size === "md" || size === "lg") && type !== "embedded",

		"text-sm": size === "sm",
		"text-md": size === "md",
		"text-lg": size === "lg",
	},
];
